<template>
  <!-- Header -->
  <header id="header" class="header">
    <div class="header-top">
      <div class="container">
        <div class="row">
          <div class="col-md-7">
            <div class="widget text-white sm-text-center header-top-uii">
              <i class="fa fa-clock-o"></i> Jam Pelayanan Rawat Jalan : Senin -
              Minggu, Jam 08.00 - 21.00 WIB
            </div>
          </div>
          <div class="col-md-5">
            <div class="widget text-white">
              <ul class="list-inline text-right sm-text-center">
                <li v-if="!logged">
                  <b-link :to="{ path: '/login' }">Login</b-link>
                </li>
                <li v-if="!logged" class>|</li>
                <li v-if="!logged">
                  <b-link :to="{ path: '/sign-up' }">Register</b-link>
                </li>
                <li v-if="!logged" class>|</li>
                <li v-if="logged" class>
                  {{ user_data.email }}
                  <span v-if="user_data.rm != null">
                    [ RM-
                    <b>{{ user_data.rm }}</b> ]
                  </span>
                </li>
                <li v-if="logged" class>|</li>
                <li v-if="logged" class>
                  <button @click="logout" class="btn-logout">Logout</button>
                </li>
                <li v-if="logged" class>|</li>
                <li>
                  <a href="mailto:contact@rsuii.co.id">Support</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-middle">
      <div class="container pt-20 pb-20">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-5 logo-uii">
            <b-link class="pull-left" :to="{ path: '/' }">
              <img src="../assets/logo.png" />
            </b-link>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-7">
            <div class="header-widget-contact-info-box">
              <div class="media element contact-info emergency mt-xs-20">
                <b-badge variant="danger" class="sirine">
                  <div class="media-left">
                    <a href="javascript:;">
                      <i
                        class="fa fa fa-ambulance text-theme-colored font-icon"
                      ></i>
                    </a>
                  </div>
                  <div class="media-body">
                    <a href="javascript:;" class="title">IGD 24 JAM</a>
                    <h3 class="media-heading subtitle">281-2111</h3>
                  </div>
                </b-badge>
              </div>
              <div class="media element contact-info">
                <div class="media-left">
                  <a href="#">
                    <i
                      class="fa fa-hospital-o text-theme-colored font-icon"
                    ></i>
                  </a>
                </div>
                <div class="media-body">
                  <a href="javascript:;" class="title"
                    >Jl. Srandakan Km. 5,5, Pandak, Bantul</a
                  >
                  <h5 class="media-heading subtitle">
                    Daerah Istimewa Yogyakarta 55761
                  </h5>
                  <h5 class="title hotline mt-5">Hotline: (0274) 2812-999</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 mobile-nav-search">
            <b-nav-form lg="12">
              <b-input-group>
                <b-form-input placeholder="Cari Berita"></b-form-input>
                <b-input-group-append>
                  <b-button variant="warning" type="submit">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-nav-form>
          </div>
        </div>
      </div>
    </div>
    <div class="header-nav">
      <div class="header-nav-wrapper navbar-scrolltofixed">
        <div class="container">
          <b-navbar toggleable="md" type="light">
            <b-navbar-toggle
              target="nav-collapse"
              class="light-btn"
            ></b-navbar-toggle>
            <b-collapse is-nav id="nav-collapse">
              <i
                v-if="isLoadingMenu"
                class="fa fa-spinner fa-spin fa-3x fa-fw"
                style="color: white"
              ></i>
              <b-navbar-nav>
                <b-nav-item-dropdown
                  v-for="menu in menus"
                  :key="menu.id"
                  :text="menu.label"
                  left
                >
                  <div v-if="menu.child != null">
                    <b-dropdown-item
                      v-for="mc in menu.child"
                      :href="mc.external === 'y' ? mc.link : ''"
                      :to="mc.external === 'n' ? { path: mc.link } : ''"
                      :key="mc.id"
                      :class="mc.child != null ? 'have-subnav' : ''"
                      :target="mc.external === 'n' ? '_self' : '_blank'"
                    >
                      <div v-html="mc.label"></div>

                      <b-navbar-nav v-if="mc.child != null" class="subnav">
                        <b-nav-item
                          v-for="mcc in mc.child"
                          :key="mcc.id"
                          :to="{ path: mcc.link }"
                          :class="mcc.child != null ? 'have-subsubnav' : ''"
                        >
                          <div>{{ mcc.label }}</div>
                          <ul
                            :class="
                              mcc.child != null
                                ? 'navbar-nav subsubnav'
                                : 'navbar-nav'
                            "
                            v-if="mcc.child != null"
                          >
                            <li
                              :class="mcc.child != null ? 'nav-item' : ''"
                              v-for="mccc in mcc.child"
                              :key="mccc.id"
                            >
                              <router-link :to="mccc.link">{{
                                mccc.label
                              }}</router-link>
                            </li>
                          </ul>
                        </b-nav-item>
                      </b-navbar-nav>
                    </b-dropdown-item>
                  </div>
                </b-nav-item-dropdown>
              </b-navbar-nav>

              <b-navbar-nav class="ml-auto search-nav">
                <b-nav-form v-on:submit.prevent="searchData()">
                  <b-input-group>
                    <b-form-input
                      v-model="search"
                      placeholder="Cari"
                    ></b-form-input>
                    <b-form-select
                      v-model="type_search"
                      :options="options"
                    ></b-form-select>
                    <b-input-group-append>
                      <b-button
                        class="my-sm-0"
                        variant="warning"
                        @click="searchData()"
                      >
                        <i class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import router from "../router";
import api from "../services/api";

import { ACTION_SET_ARTICLES } from "../store/repo/pages";

export default {
  data() {
    return {
      search: "",
      logged: false,
      isLoadingMenu: false,
      user_data: "",
      type_search: "articles",
      menus: [],
      options: [
        { value: "articles", text: "Artikel" },
        { value: "doctor", text: "Dokter" }
      ]
    };
  },
  mounted() {
    let getUserData = localStorage.getItem("user_data");
    if (getUserData != undefined) {
      this.logged = true;
      this.user_data = JSON.parse(getUserData);
    }

    this.getMenus();
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  },
  methods: {
    logout() {
      let conf = confirm("Anda yakin untuk keluar?");
      if (conf) {
        localStorage.removeItem("user_data");
        router.push({ name: "home" });
        window.location.reload();
      }
    },
    searchData() {
      if (this.type_search == "articles") {
        this.$store.dispatch(ACTION_SET_ARTICLES, { s: this.search });
        const path = "/berita/" + this.search;
        if (this.currentRouteName != path) this.$router.push(path);
      } else {
        const path = "cari-dokter";
        if (this.currentRouteName != path)
          this.$router.push({ name: path, params: { search: this.search } });
        else alert("Silahkan melakukan pencarian di halaman ini");
      }
      this.search = "";
    },
    getMenus() {
      this.isLoadingMenu = true;
      api
        .post(api.route.get.menus)
        .then(res => {
          let status = res.status;
          if (status) {
            let data = res.data;
            this.menus = data;
          }
          this.isLoadingMenu = false;
        })
        .catch(err => {
          console.log(err);
          this.isLoadingMenu = false;
        });
    }
  }
};
</script>
<style>
.btn-logout {
  background: transparent;
  color: white;
  border: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue